import React from 'react'
import { Fragment } from 'react'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import FooterDesktop from '../components/common/FooterDesktop';
import FooterMobile from '../components/common/FooterMobile';
import { useLocation } from 'react-router';
import OrderProcess from '../components/orders/OrderProcess';
function OrderProcessPage(props) {
    const User = props.user;
    const {state} = useLocation();
  return (
    <Fragment>
    <div className='Desktop'>
      <NavMenuDesktop user={User}/>
    </div>
    <div className='Mobile'>
    <NavMenuMobile />
    </div>
  
    <OrderProcess user={User} data={state}/>
    
    <div className='Desktop'>
    <FooterDesktop />
    </div>

    <div className='Mobile'>
      <FooterMobile />
    </div>
  </Fragment>
  )
}

export default OrderProcessPage
